/* global Camera, device, LocalFileSystem */

var cordovaApp = {
  f7: null,
  /*
   This method hides splashscreen after 2 seconds
   */
  handleSplashscreen: function () {
    var f7 = cordovaApp.f7;
    if (!window.navigator.splashscreen || f7.device.electron)
      return;
    setTimeout(() => {
      window.navigator.splashscreen.hide();
    }, 2000);
  },
  /*
   This method prevents back button tap to exit from app on android.
   In case there is an opened modal it will close that modal instead.
   In case there is a current view with navigation history, it will go back instead.
   */
  handleAndroidBackButton: function () {
    var f7 = cordovaApp.f7;
    const $ = f7.$;
    if (f7.device.electron)
      return;

    document.addEventListener('backbutton', function (e) {
      if ($('.actions-modal.modal-in').length) {
        f7.actions.close('.actions-modal.modal-in');
        e.preventDefault();
        return false;
      }
      if ($('.dialog.modal-in').length) {
        f7.dialog.close('.dialog.modal-in');
        e.preventDefault();
        return false;
      }
      if ($('.sheet-modal.modal-in').length) {
        f7.sheet.close('.sheet-modal.modal-in');
        e.preventDefault();
        return false;
      }
      if ($('.popover.modal-in').length) {
        f7.popover.close('.popover.modal-in');
        e.preventDefault();
        return false;
      }
      if ($('.popup.modal-in').length) {
        if ($('.popup.modal-in>.view').length) {
          const currentView = f7.views.get('.popup.modal-in>.view');
          if (currentView && currentView.router && currentView.router.history.length > 1) {
            currentView.router.back();
            e.preventDefault();
            return false;
          }
        }
        f7.popup.close('.popup.modal-in');
        e.preventDefault();
        return false;
      }
      if ($('.login-screen.modal-in').length) {
        f7.loginScreen.close('.login-screen.modal-in');
        e.preventDefault();
        return false;
      }

      if ($('.page-current .searchbar-enabled').length) {
        f7.searchbar.disable('.page-current .searchbar-enabled');
        e.preventDefault();
        return false;
      }

      if ($('.page-current .card-expandable.card-opened').length) {
        f7.card.close('.page-current .card-expandable.card-opened');
        e.preventDefault();
        return false;
      }

      const currentView = f7.views.current;
      if (currentView && currentView.router && currentView.router.history.length > 1) {
        currentView.router.back();
        e.preventDefault();
        return false;
      }

      if ($('.panel.panel-in').length) {
        f7.panel.close('.panel.panel-in');
        e.preventDefault();
        return false;
      }
    }, false);
  },
  /*
   This method does the following:
   - provides cross-platform view "shrinking" on keyboard open/close
   - hides keyboard accessory bar for all inputs except where it required
   */
  handleKeyboard: function () {
    var f7 = cordovaApp.f7;
    if (!window.Keyboard || !window.Keyboard.shrinkView || f7.device.electron)
      return;
    var $ = f7.$;
    window.Keyboard.shrinkView(false);
    window.Keyboard.disableScrollingInShrinkView(true);
    window.Keyboard.hideFormAccessoryBar(true);
    window.addEventListener('keyboardWillShow', () => {
      f7.input.scrollIntoView(document.activeElement, 0, true, true);
    });
    window.addEventListener('keyboardDidShow', () => {
      f7.input.scrollIntoView(document.activeElement, 0, true, true);
    });
    window.addEventListener('keyboardDidHide', () => {
      if (document.activeElement && $(document.activeElement).parents('.messagebar').length) {
        return;
      }
      window.Keyboard.hideFormAccessoryBar(false);
    });
    window.addEventListener('keyboardHeightWillChange', (event) => {
      var keyboardHeight = event.keyboardHeight;
      if (keyboardHeight > 0) {
        // Keyboard is going to be opened
        document.body.style.height = `calc(100% - ${keyboardHeight}px)`;
        $('html').addClass('device-with-keyboard');
      } else {
        // Keyboard is going to be closed
        document.body.style.height = '';
        $('html').removeClass('device-with-keyboard');
      }

    });
    $(document).on('touchstart', 'input, textarea, select', function (e) {
      var nodeName = e.target.nodeName.toLowerCase();
      var type = e.target.type;
      var showForTypes = ['datetime-local', 'time', 'date', 'datetime'];
      if (nodeName === 'select' || showForTypes.indexOf(type) >= 0) {
        window.Keyboard.hideFormAccessoryBar(false);
      } else {
        window.Keyboard.hideFormAccessoryBar(true);
      }
    }, true);
  },
  camera: async (options) => {
    //
    // usa cordova-plugin-camera
    // https://github.com/apache/cordova-plugin-camera
    //
    const defOptions = {
      quality: 85,
      targetWidth: 900,
      targetHeight: 900,
      destinationType: Camera.DestinationType.DATA_URL,
    };

    if (options) {
      defOptions.cameraDirection = options.front ? Camera.Direction.FRONT : Camera.Direction.BACK;
      defOptions.allowEdit = options.allowEdit || false;
      defOptions.sourceType = options.gallery ? Camera.PictureSourceType.PHOTOLIBRARY : Camera.PictureSourceType.CAMERA;
    }

    return new Promise((resolve, reject) => {
      const cameraSuccess = (imageData) => {
        resolve("data:image/jpeg;base64," + imageData);
      }
      const cameraError = (message) => {
        reject(message);
      }
      navigator.camera.getPicture(cameraSuccess, cameraError, defOptions);
    });

  },
  cameraAndroidCrop: async (gallery) => {
    //
    // usa cordova-plugin-camera
    // https://github.com/apache/cordova-plugin-camera
    // 
    // usa cordova-plugin-crop
    // https://github.com/jeduan/cordova-plugin-crop
    //
    const defOptions = {
      quality: 85,
      targetWidth: 900,
      targetHeight: 900,
      destinationType: Camera.DestinationType.FILE_URI,
      sourceType: gallery ? Camera.PictureSourceType.PHOTOLIBRARY : Camera.PictureSourceType.CAMERA,
    };

    return new Promise((resolve, reject) => {
      const fail = (evt) => reject(evt.target.error.message);
      const getFileContentAsBase64 = (path, callback) => {
        function gotFile(fileEntry) {
          fileEntry.file(function (file) {
            var reader = new FileReader();
            reader.onloadend = function (e) {
              var content = this.result;
              callback(content);
            };
            reader.readAsDataURL(file);
          });
        }
        window.resolveLocalFileSystemURL(path, gotFile, fail);
      }
      const cameraSuccess = (imagePath) => {
        plugins.crop((success) => {
          console.log(success, 'crop(success)');
          getFileContentAsBase64(success, (b64) => resolve(b64));
        }, (fail) => reject(fail), 'file://' + imagePath, {quality: 100})
      }
      const cameraError = (message) => {
        reject(message);
      }
      navigator.camera.getPicture(cameraSuccess, cameraError, defOptions);
    });
  },
  qrscan: async function () {

    return new Promise((resolve, reject) => {
      const options = {
        preferFrontCamera: false, // iOS and Android
        showFlipCameraButton: true, // iOS and Android
        showTorchButton: true, // iOS and Android
        torchOn: false, // Android, launch with the torch switched on (if available)
        saveHistory: false, // Android, save scan history (default false)
        prompt: lng.qrscan_prompt, // Android
        resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
        formats: "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
        //orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
        disableAnimations: false, // iOS
        disableSuccessBeep: false // iOS and Android
      };
      const success = (result) => {
        console.log(result, 'Scan QR Code Success');
        resolve(result)
      }

      const fail = (e) => {
        console.log(e, 'Scan QR Code fail');
        reject(e);
      }
      cordova.plugins.barcodeScanner.scan(success, fail, options);
    });

  },
  messaging: function () {

    // cordova-plugin-firebase-messaging
    // https://www.npmjs.com/package/cordova-plugin-firebase-messaging
    console.log('messaging init');

    /*
     * onMessage(callback)
     * 
     * Called when a push message received while app is in foreground.
     * NOTE: on iOS make sure notification payload contains key content-available with value 1. 
     * Otherwise this callback is never fired.
     * @type type
     */
    cordova.plugins.firebase.messaging.onMessage(function (payload) {
      console.log("New foreground FCM message: ", payload);
    });

    /*
     * onBackgroundMessage(callback)
     * 
     * Called when a push message received while app is in background.
     */
    cordova.plugins.firebase.messaging.onBackgroundMessage(function (payload) {
      console.log("New background FCM message: ", payload);
    });

    /*
     * getToken(type)
     * 
     * Returns a promise that fulfills with the current FCM token.
     * 
     * This method also accepts optional argument type. Currently iOS platform supports values "apns-buffer" and "apns-string" 
     * that defines presentation of resolved APNS token:
     * cordova.plugins.firebase.messaging.getToken("apns-string").then(function(token) {
     *   console.log("APNS hex device token: ", token);
     * });
     */
    const getToken = () => {
      cordova.plugins.firebase.messaging.getToken().then(function (token) {
        myStorage.set('uuid', device.uuid);
        console.log('uuid', device.uuid);
        myApp.server.put('user/me/fcm', {token: token, uuid: device.uuid})
          .then((res) => res.json())
          .then((data) => data.error ? console.log('FCM error: ' + data.error.code + ' ' + data.error.message) : console.log(data, 'FCM Token aggiornato'))
          .catch((e) => console.log('FCM error: ' + e.message));
      });
    }
    getToken();

    /*
     * onTokenRefresh(callback)
     * 
     * Triggers every time when FCM token updated. You should usually call getToken to get an updated token and send it to server.
     */
    cordova.plugins.firebase.messaging.onTokenRefresh(function () {
      console.log("Device token updated");
      getToken();
    });

    /*
     * requestPermission(options)
     * 
     * Grant permission to recieve push notifications (will trigger prompt on iOS).
     * In options object you can specify a boolean setting forceShow. 
     * When true this setting forces notification to display even when app is in foreground:
     */
    cordova.plugins.firebase.messaging.requestPermission({forceShow: false}).then(function () {
      console.log("Push messaging is allowed");
    });


    /*
     * clearNotifications
     * 
     * Clear all notifications from system notification bar.
     */
    const clearNotifications = () => {
      cordova.plugins.firebase.messaging.clearNotifications(function () {
        console.log("Notification messages cleared successfully");
      });
    }

    /*
     * deleteToken
     * 
     * Delete the Instance ID (Token) and the data associated with it. Call getToken to generate a new one.
     */
    const deleteToken = () => {
      cordova.plugins.firebase.messaging.deleteToken().then(function () {
        console.log("Token revoked successfully");
      });
    }

    /*
     * getBadge
     * 
     * Reads current badge number (if supported).
     */
    const getBadge = () => {
      cordova.plugins.firebase.messaging.getBadge().then(function (value) {
        console.log("Badge value: ", value);
      });
    }

    /*
     * setBadge(value)
     * 
     * Sets current badge number (if supported).
     */
    const setBadge = (value) => {
      cordova.plugins.firebase.messaging.setBadge(value);
    }
  },
  init: function (f7) {
    // Save f7 instance
    cordovaApp.f7 = f7;

    // Handle Android back button
    cordovaApp.handleAndroidBackButton();

    // Handle Splash Screen
    cordovaApp.handleSplashscreen();

    // Handle Keyboard
    cordovaApp.handleKeyboard();

  },
};

export default cordovaApp;
